<template>
  <div>
    <loading-spinner v-if='loading'></loading-spinner>
    <transition-group v-else name="list" tag='div'>
      <div v-for='category in filteredCategories' :key='category'>
        <h2>{{categoryNames[category].name}}</h2>
        <div class='eventTiles'>
          <div v-for='event in getCategory(category)' class='eventTile' :key='event.title'>
            <span class='sash' v-if='event.sash'>{{event.sash}}</span>
            <!-- todo: refactor repeated contents -->
            <a v-if='event.redirectTo' :href='event.redirectTo'>
              <div>
                <img :src='event.thumbnail.filename' v-if='event.thumbnail'> 
                <div class='eventText' :class='getColour(event)'><h2>{{event.navigationLabel || event.title}}</h2><h3><!--{{event.navigationSubtitle}}--> {{formatDate(event)}}</h3></div>
              </div>
            </a>

            <router-link v-else :to="{name: 'whatsondetail', params: { slug: event.urlSegment }}">
              <div>
                <img :src='event.thumbnail.filename' v-if='event.thumbnail'> 
                <div class='eventText' :class='getColour(event)'><h2>{{event.navigationLabel || event.title}}</h2><h3><!--{{event.navigationSubtitle}}--> {{formatDate(event)}}</h3></div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import DatePicker from '../components/DatePicker'
import moment from 'moment'
import LoadingSpinner from '../components/LoadingSpinner'

export default {
  props: ['query'],
  data() {
    return {
      categoryNames: {
        'Event': {name: 'Programmes and Events'},
        'Exhibition': {name: 'Exhibitions and Displays'},
        'Gallery': {name: 'Galleries'},
        'Show': {name: 'Planetarium Shows'},
        'GuidedTour': {name: 'Guided Tours'},
        'Tour': {name: 'Guided Tours For Cruise Ships'} // Cruise Ship Guided Tours
      },
      categoryMap: {
        'Event': {category: 'Event', class: 'cs-navy-events'},
        'Show': {category: 'Show', class: 'cs-red-pgp'},
        'GuidedTour': {category: 'GuidedTour', class: 'cs-green-tours'},
        'Tour': {category: 'Tour', class: 'cs-green-tours'},
        'Exhibition': {category: 'Exhibition', class: 'cs-cerulean'},
        'Display': {category: 'Exhibition', class: 'cs-teal-displays'},
        'Gallery': {category: 'Gallery', class: 'cs-yellow-galleries'},
      },
      tagMap: {
        'Perpetual Guardian Planetarium': { category: 'Show'},
        'Event': { category: 'Event' },
        'Public Tour': { category: 'GuidedTour'},
        'Cruise Ship Tour': { category: 'Tour'}
      },
      selectedCategories:  ['Show', 'Event','Exhibition', 'Display', 'Gallery'],
      categories: {},
      dateFrom: null,
      dateTo: null,
      loading: true
    }
  },
  computed: {
    filteredCategories() {
      let headings = _.map(this.selectedCategories, (x) => this.categoryMap[x].category);
      headings = _.uniq(headings);

      headings = _.sortBy(headings, x=>_.keys(this.categoryMap).indexOf(x));
      return headings;
    }
  },
  methods: {
      dateChange(e) {
        this.dateFrom = e.dateFrom;
        this.dateTo = e.dateTo;
        this.update();
      },
      update() {
        // if (this.query) {
        //     if (this.$route.categories) {
        //         this.selectedCategories = this.$route.categories.split(',');
        //     }
        // }

        let query = JSON.stringify( {
            fromDate: this.dateFrom,
            toDate: this.dateTo
        });

        this.categories = {};

        axios.get(`${this.$api}/event/search?query=${query}`).then(
        (result) => {
          for (let i = 0; i < result.data.length; i++) {
            let item = result.data[i];

            if (item.hide === true) {
              continue;
            }

            let categoryName = this.categoryMap[item.class].category;
            if (this.categories[categoryName] == undefined) {
                this.$set(this.categories, categoryName, []);
            }

            this.categories[categoryName].push(item);
            
            if ('tags' in item) {
              for (const tag of item.tags) {
                if (tag.title in this.tagMap) {
                  categoryName = this.tagMap[tag.title].category;

                  if (this.categories[categoryName] == undefined) {
                    this.$set(this.categories, categoryName, []);
                  }

                  if (!this.categories[categoryName].includes(item)) {
                    this.categories[categoryName].push(item);
                  }
                }
              }
            }

            if (item.title == 'Tūhura Otago Community Trust Science Centre') {
              this.categories['Exhibition'].push(item);
            }
          }

          this.loading = false;
        });
      },
      formatDate(event) {
        if (event.class =='Show' && event.instances && event.instances.length > 0 && event.showNextSession) {
          let date = moment(event.instances[0].Date);

          return "Next show: " +  date.calendar(null, {
            sameDay: 'h.mma [Today]',
            nextDay: 'h.mma [Tomorrow]',
            nextWeek: 'h.mma, dddd D MMMM',
            lastDay: '[Yesterday]',
            lastWeek: '[Last] dddd',
            sameElse: 'h.mma, dddd D MMMM '
          });
        } else {
          return event.navigationSubtitle;
        }
      },
      getColour(event) {
        if (event.overrideColour && event.overrideColour != '') {
          return event.overrideColour;
        } else {
          return this.categoryMap[event.class].class;
        }
      },
      getCategory(category) {
        return _.sortBy(this.categories[category], x => x.priority);
      }
  },
  watch: {
    '$route'() {
      if (this.query) {
        if (this.query.categories) {
          this.selectedCategories = this.query.categories.split(',');
        }
      }
    }
  },
  created() {
      if (this.query) {
        if (this.query.categories) {
          this.selectedCategories = this.query.categories.split(',');
        }
      }

      this.update();
  },
  components: {
      'date-picker': DatePicker,
      'loading-spinner': LoadingSpinner
  }
}
</script>

<style lang="less">


#whats-on-filter  {
    input[type=checkbox] {
        margin-left: 10px;
    }

    label {
        margin-left: 5px;
    }
}

.eventTiles {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
}

.eventTiles::after {
  content: "";
  flex: auto;
  flex-basis: 23.5%;
}

.eventTile {
  position:relative;
  overflow: hidden;
  min-height: 435px;
  flex-basis: 23.5%;
  margin-bottom: 1.5%;
  margin-right: 1.5%;
  display: flex;

  img {
    display: block;
    width: 100%;
  }
}

.eventText {
  //position: absolute;
  bottom: 0;
  color: white;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  text-transform: uppercase;
  font-weight: bold;
  font-size: 8px;
  min-height: 170px;
}


.list-item {
  transition: all 0.5s;
}
.list-enter, .list-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-leave {
    transition: all 1s;
}

.list-move {
  transition: transform 0.5s;
}

.datePicker {
  margin-bottom: 10px;
}

.cs-cerulean {
    background-color: rgba(0,133,171,1)
}

.cs-rose {
    background-color: rgba(230,0,126,1)
}

.cs-robins-egg-blue {
    background-color: rgba(4,198,205,1)
}

.cs-tangerine {
    background-color: rgba(243,146,0,1)
}

.cs-vermilion {
    background-color: rgba(250,59,0,1)
}

.cs-atlantis {
    background-color: rgba(145,208,41,1)
}

.cs-candlelight {
    background-color: rgba(255,210,20,1)
}

.cs-baltic-sea {
    background-color: rgba(91,89,93,1)
}
.cs-purple {
    background-color: rgba(164,13,178,1)
}

.cs-pistachio {
    background-color: rgba(153,162,9,1)
}


.cs-burnt-orange {
    background-color: rgba(215,63,11,1)
}

.cs-moss {
    background-color: rgba(72,104,20,1)
}

.cs-orange-learn {
    background-color: rgba(234,81,33,1)
}


.cs-purple-venues {
    background-color: rgba(175,89,156,1)
}


.cs-red-pgp {
    background-color: rgba(226,55,84,1)
}

.cs-navy-events {
    background-color: rgba(41,63,102,1)
}

.cs-green-tours {
    background-color: rgba(62,140,71,1)
}

.cs-yellow-galleries {
    background-color: rgba(242,181,71,1)
}


.cs-teal-displays {
    background-color: rgba(65,191,179,1)
}


.cs-green-dwtf {
    background-color: rgba(110,193,66,1)
}


.cs-purple-cafe {
    background-color: rgba(51,19,68,1)
}

span.sash {
    position: absolute;
    transform: rotate(30deg);
    background: rgba(177,100,100,0.7);
    width: 100%;
    color: white;
    top: 34px;
    left: 56px;
    text-align: center;
    font-weight: bold;
    padding: 3px;
    text-transform: uppercase;
}

@media only screen and (max-width: 1200px) {
  .eventTiles .eventTile {
      flex-basis: 31%;
  }
}

@media only screen and (max-width: 980px) {
    .eventTiles .eventTile {
      flex-basis: 45%;
    }
}

@media only screen and (max-width: 630px) {
    .eventTiles {
      justify-content: space-around;

      .eventTile {
        flex-basis: 80%;
        display: inline-block;
      }
    }
}
</style>





